import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const helpers = window.BASE_HELPERS || {};
const { Mobile } = helpers;

const MODULE = document.querySelectorAll('[data-module="noticias_destaque"]');

class NoticiasDestaque {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach(component => {
            if (Mobile.isMobile()) {
                const swiperComponent = component.querySelector('.swiper');
                if (swiperComponent) this.initSwiper(swiperComponent);
            }
        });
    }

    initSwiper(swiperComponent) {
        new Swiper(swiperComponent, {
            modules: [Pagination, Navigation, Autoplay],
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 20,
            navigation: {
                nextEl: swiperComponent.querySelector('.swiper-button-next'),
                prevEl: swiperComponent.querySelector('.swiper-button-prev'),
            },
        });
    }
}

(() => {
    if (MODULE) {
        new NoticiasDestaque();
    }
})();

export default NoticiasDestaque;
